import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'ghost';
interface ButtonProps {
  to?: string;
  href?: string;
  onClick?: () => void;
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
  type?: 'button' | 'submit';
}
const base = 'inline-flex items-center justify-center gap-2 rounded-brand px-7 py-3.5 text-sm font-medium transition-colors duration-150 ease-republic';
const variants: Record<Variant, string> = {
  // Gold fill with onyx type — the single loudest element on any screen.
  primary: 'bg-brick text-cream hover:bg-brick-deep',
  // Champagne hairline that fills to champagne on hover.
  secondary: 'border border-ink/30 text-ink hover:border-ink hover:bg-ink hover:text-cream',
  // For use on the champagne accent band: onyx hairline that fills to onyx.
  ghost: 'border border-cream/40 text-cream hover:bg-cream hover:text-ink'
};
export function Button({
  to,
  href,
  onClick,
  variant = 'primary',
  children,
  className = '',
  type = 'button'
}: ButtonProps) {
  const classes = `${base} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={classes} data-id="element-251" data-mp="er7efk9uls8j">
        {children}
      </Link>;
  }
  if (href) {
    return <a href={href} className={classes} data-id="element-252" data-mp="to8afzz2o9ct">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} className={classes} data-id="element-253" data-mp="om96anvid8et">
      {children}
    </button>;
}